import api from '../../../api'
import roles from '../../../helpers/userRoles'
import modal from '../../../components/modal.vue'
import maskedInput from '../../../components/masked-input.vue'
import MoveToCompanyPopup from './MoveToCompanyPopup.vue'

const mapClient = client => {
  return {
    id: client.id,
    name: client.name,
    email: client.email,
    phone: client.telephone,
    description: client.description,
    adAgent: client.ad_agent,
    inEditing: false
  }
}

const getClient = () => {
  return {
    name: '',
    email: '',
    phone: '',
    description: ''
  }
}

export default {
  name: 'Private',
  components: {
    modal,
    'masked-input': maskedInput
  },
  data: () => {
    return {
      clients: [],
      client: getClient(),
      searchText: '',
      clientBackups: [],
      showModal: false,
      tableHeaderItems: []
    }
  },
  methods: {
    loadClients () {
      api.get
        .clients()
        .then(resp => {
          this.clients = resp.data.data.clients
            .filter(x => !x.legal_entity)
            .map(mapClient)
            .sort(function (a, b) {
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1
              }
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1
              }
              return 0
            })
          this.searchText = ''
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    },
    editClient (client) {
      const clientIndex = this.clients.findIndex(x => x.id === client.id)
      this.clientBackups[clientIndex] = Object.assign({}, client)
      client.inEditing = true
      this.clients.splice(clientIndex, 1, client)
    },
    cancelEditing (client) {
      const clientIndex = this.clients.findIndex(x => x.id === client.id)
      this.clients.splice(clientIndex, 1, this.clientBackups[clientIndex])
      this.clientBackups[clientIndex] = null
    },
    saveEditedClient (client) {
      const clientInfo = {
        clientName: client.name,
        clientEmail: client.email,
        clientPhone: client.phone,
        description: client.description
      }
      api.post
        .updateClient(clientInfo, client.id)
        .then(() => {
          const clientIndex = this.clients.findIndex(x => x.id === client.id)
          client.inEditing = false
          this.clients.splice(clientIndex, 1, client)
          this.clientBackups[clientIndex] = null
          this.$notify({
            message: 'Клиент обновлен',
            type: 'success'
          })
        })
        .catch(() => {
          this.$notify({
            message: 'Ошибка обновления клиента',
            type: 'danger'
          })
        })
    },
    addClient () {
      const clientInfo = {
        clientName: this.client.name,
        clientEmail: this.client.email,
        clientPhone: this.client.phone,
        clientDescription: this.client.description
      }

      this.clearClient()

      api.post
        .addClient(clientInfo)
        .then(() => {
          this.loadClients()
          this.$notify({
            message: 'Клиент создан',
            type: 'success'
          })
        })
        .catch(() => {
          this.$notify({
            message: 'Ошибка создания клиента',
            type: 'danger'
          })
        })
    },
    clearClient () {
      this.client = getClient()
    },
    setTableHeader () {
      this.tableHeaderItems = [
        {
          name: 'name',
          viewName: 'ФИО',
          width: 175,
          isVisible: true
        },
        {
          name: 'email',
          viewName: this.$t('home.email'),
          width: 150,
          isVisible: true
        },
        {
          name: 'phone',
          viewName: this.$t('home.phone'),
          width: 150,
          isVisible: true
        },
        {
          name: 'description',
          viewName: this.$t('home.description'),
          width: 200,
          isVisible: true
        },
        {
          name: 'actions',
          viewName: '',
          width: 125,
          isVisible: this.isUserCanEditClients
        }
      ]
    },
    clearSearchText () {
      this.searchText = ''
    },
    setCompanyNameForClient (client, companyId) {
      const requestBody = {
        legalEntity: companyId
      }
      api.post
        .updateClient(requestBody, client.id)
        .then(() => {
          const clientIndex = this.clients.findIndex(x => x.id === client.id)
          this.clients.splice(clientIndex, 1)
        })
        .catch(() => {
          this.$notify({
            message: 'Произошла ошибка',
            type: 'danger'
          })
        })
    },
    setAdAgent (client) {
      client.adAgent = true
      api.post
        .updateClient(client, client.id)
        .then(() => {
          const clientIndex = this.clients.findIndex(x => x.id === client.id)
          this.clients.splice(clientIndex, 1, client)
          this.$notify({
            message: 'Приглашение отправлено',
            type: 'success'
          })
        })
        .catch(() => {
          client.adAgent = false
          this.$notify({
            message: 'Клиент уже создан в системе',
            type: 'danger'
          })
        })
    },
    showMoveToCompanyPopup (client) {
      const moveToCompanyAction = (companyId) => this.setCompanyNameForClient(client, companyId)
      this.$modal.show(MoveToCompanyPopup, {
        moveToCompanyAction
      }, {
        height: 'auto'
      })
    }
  },
  computed: {
    filteredClients () {
      if (!this.searchText) {
        return this.clients
      }

      return this.clients.filter(x => {
        return Object.keys(x)
          .map(key => x[key])
          .filter(x => x)
          .some(
            y =>
              y
                .toString()
                .toLowerCase()
                .indexOf(this.searchText.toLowerCase()) > -1
          )
      })
    },
    isUserCanEditClients () {
      return (
        this.$store.getters.role === roles.manager ||
        this.$store.getters.role === roles.director
      )
    },
    isUserCanInviteAdAgent () {
      return this.$store.getters.role === roles.director
    },
    isClientValid () {
      return !!this.client.name && !!(this.client.email || this.client.phone)
    }
  },
  created: function () {
    this.loadClients()
    this.setTableHeader()
  },
  beforeRouteLeave (to, from, next) {
    if (this.clients.some(x => x.inEditing)) {
      this.showModal = true
      this.showModal = this.onClickYesButton = () => {
        this.showModal = false
        next()
      }
      this.onClickNoButton = () => {
        this.showModal = false
      }
    } else {
      next()
    }
  }
}
